import { render, staticRenderFns } from "./QueryRootsTreeDetailMenu.vue?vue&type=template&id=313bbef8&"
import script from "./QueryRootsTreeDetailMenu.vue?vue&type=script&lang=js&"
export * from "./QueryRootsTreeDetailMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports